export default __webpack_public_path__ + "static/1-e4eb3b8444cf9404ee97953f76ab3882.gif";